export default "__VITE_ASSET__f73e6e79__"